(function () {
  "use strict";

  var CLIENT_NAME     = "Coffee Mais";
  var PLAY_STORE_URL  = "https://play.google.com/store/apps/details?id=com.converta.coffeemais&hl=pt_BR";
  var APPLE_STORE_URL = "https://apps.apple.com/br/app/coffee-mais-oficial/id6756785765";

  var storageKey    = "coffeeMiniAppBannerFinalHiddenUntil";
  var sevenDaysInMs = 7 * 24 * 60 * 60 * 1000;

  function start() {
    var ua            = (navigator.userAgent || "").toLowerCase();
    var platform      = navigator.platform || "";
    var maxTouchPoints = navigator.maxTouchPoints || 0;

    // Já está dentro do app (webview Converta): não mostra
    if (ua.indexOf("converta") !== -1) return;

    // Landings do clube (mensal/anual): header próprio, sem banner de app
    if (document.querySelector(".clube-mensal-page, .clube-anual-page")) return;

    var isAndroid = ua.indexOf("android") !== -1;
    var isIOS     = /iphone|ipad|ipod/.test(ua) || (platform === "MacIntel" && maxTouchPoints > 1);
    var isMobile  = isAndroid || isIOS || /mobile/.test(ua);

    if (!isMobile) return;
    if (document.getElementById("coffeeMiniAppBannerFinal")) return;

    var APP_URL = isIOS ? APPLE_STORE_URL : PLAY_STORE_URL;

    // Respeita o "fechar por 7 dias"
    try {
      var hiddenUntil = Number(localStorage.getItem(storageKey));
      if (hiddenUntil && Date.now() < hiddenUntil) return;
      if (hiddenUntil) localStorage.removeItem(storageKey);
    } catch (e) {}

    injectBanner(APP_URL);
  }

  function injectBanner(APP_URL) {
    if (!document.body || !document.head) return;
    if (document.getElementById("coffeeMiniAppBannerFinal")) return;

    var style = document.createElement("style");
    style.id = "coffeeMiniAppBannerFinalStyle";
    style.innerHTML =
      ".coffee-mini-app-banner-final{" +
        "position:fixed;top:0;right:0;left:0;z-index:200;display:block;padding:0 8px;font-family:Inter,Arial,sans-serif;color:#fff4ea;box-sizing:border-box;" +
      "}" +
      ".coffee-mini-app-banner-final.is-hidden{display:none;}" +
      ".coffee-mini-app-banner-final__inner{" +
        "position:relative;box-sizing:border-box;width:100%;max-width:390px;margin:0 auto;padding:10px 34px 10px 12px;border:1px solid #3c2f23;border-radius:0 0 18px 18px;background:#000;box-shadow:0 10px 28px rgba(0,0,0,.35);" +
      "}" +
      ".coffee-mini-app-banner-final__content{" +
        "display:grid;grid-template-columns:minmax(0,1fr) auto;gap:10px;align-items:center;" +
      "}" +
      ".coffee-mini-app-banner-final__copy{min-width:0;}" +
      ".coffee-mini-app-banner-final__title{" +
        "margin:0;color:#fff0e4;font-size:15px;font-weight:800;line-height:1.05;" +
      "}" +
      ".coffee-mini-app-banner-final__text{" +
        "margin:4px 0 0;color:rgba(255,244,234,.82);font-size:12px;font-weight:500;line-height:1.22;" +
      "}" +
      ".coffee-mini-app-banner-final__text-highlight{" +
        "font-family:Georgia,'Times New Roman',serif;font-size:11px;font-style:italic;font-weight:400;opacity:.86;white-space:nowrap;" +
      "}" +
      ".coffee-mini-app-banner-final__cta{" +
        "display:flex;min-height:36px;padding:0 14px;align-items:center;justify-content:center;border-radius:999px;background:#ffc477;color:#1e1e1e!important;font-size:12px;font-weight:800;letter-spacing:.02em;line-height:1;text-align:center;text-decoration:none;white-space:nowrap;" +
      "}" +
      ".coffee-mini-app-banner-final__close{" +
        "position:absolute;top:4px;right:7px;width:24px;height:24px;border:0;padding:0;background:transparent;color:#ffc477;cursor:pointer;font-size:24px;font-weight:300;line-height:20px;" +
      "}" +
      "#coffeeMiniAppBannerFinalSpacer{display:block;width:100%;height:74px;}" +
      "@media (min-width:768px){.coffee-mini-app-banner-final{display:none!important;}#coffeeMiniAppBannerFinalSpacer{display:none!important;}}";

    document.head.appendChild(style);

    var spacer = document.createElement("div");
    spacer.id = "coffeeMiniAppBannerFinalSpacer";

    var banner = document.createElement("div");
    banner.id = "coffeeMiniAppBannerFinal";
    banner.className = "coffee-mini-app-banner-final";
    banner.innerHTML =
      '<div class="coffee-mini-app-banner-final__inner">' +
        '<div class="coffee-mini-app-banner-final__content">' +
          '<div class="coffee-mini-app-banner-final__copy">' +
            '<p class="coffee-mini-app-banner-final__title">Ganhe 20% OFF</p>' +
            '<p class="coffee-mini-app-banner-final__text">Baixe e use o cupom APP20 na primeira compra pelo app. <span class="coffee-mini-app-banner-final__text-highlight">(em itens selecionados)</span></p>' +
          '</div>' +
          '<a class="coffee-mini-app-banner-final__cta" href="' + APP_URL + '">BAIXE O APP</a>' +
        '</div>' +
        '<button class="coffee-mini-app-banner-final__close" type="button" aria-label="Fechar banner do app" id="coffeeMiniAppBannerFinalClose">' +
          '<span aria-hidden="true">&times;</span>' +
        '</button>' +
      '</div>';

    document.body.insertBefore(spacer, document.body.firstChild);
    document.body.insertBefore(banner, spacer);

    var closeButton = document.getElementById("coffeeMiniAppBannerFinalClose");
    if (closeButton) {
      closeButton.addEventListener("click", function () {
        try {
          localStorage.setItem(storageKey, String(Date.now() + sevenDaysInMs));
        } catch (e) {}
        banner.classList.add("is-hidden");
        if (spacer && spacer.parentNode) {
          spacer.parentNode.removeChild(spacer);
        }
      });
    }
  }

  // No theme.liquid o script roda durante o parse — espera o DOM ficar pronto.
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start);
  } else {
    start();
  }
})();